import { FC, ReactNode } from 'react';

export const SubmenuPanel: FC<{ children: ReactNode }> = ({ children }) => (
  <div className='absolute left-full top-0 z-50 pl-3'>
    <div className='flex w-max min-w-[187px] flex-col gap-1 rounded-md bg-surface p-2 shadow-medium'>
      {children}
    </div>
  </div>
);
